/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from 'react';
import RenderWhen from '@vlinder-web/react-when-module-react';
import * as S from './styles';

export interface IDigitalClockProps {
  time?: string;
}

export const DigitalClock = ({ time }: IDigitalClockProps) => {
  return (
    <>
      <RenderWhen>
        <RenderWhen.If isTrue={!!time}>
          <S.Container>
            <S.Clock>{time}</S.Clock>
          </S.Container>
        </RenderWhen.If>
      </RenderWhen>
    </>
  );
};

DigitalClock.defaultProps = {};
